import { AppDispatch, RootState } from '../index';
import { FetchState } from '../fetchState';
import { baseSlice, BaseType, getItem } from '../baseHelper';
import { companyService } from '@api/services/services';
import { CompanyPageDto } from '@api/models/settings/CompanyPageDto';

type State = BaseType<CompanyPageDto[]>;

const initialState: State = {
  state: FetchState.None,
  data: [],
};

export const companyPagesSlice = baseSlice({
  name: 'companyPages',
  initialState,
});

export const selectCompanyPagesState = (state: RootState) => state.companyPages.state;
export const selectCompanyPages = (state: RootState) => state.companyPages.data;
export const companyPagesActions = companyPagesSlice.actions;

export const getCompanyPages = () => (dispatch: AppDispatch) => {
  const handleGetData = () => {
    return companyService.queryCompanyPages();
  };

  getItem({
    dispatch,
    actions: companyPagesActions,
    getData: handleGetData,
  });
};
